import { loaderEnter, loaderLeave } from './loader';
import { introEnter, introLeave } from './intro';
import { tutorialEnter, tutorialLeave } from './tutorial';
import { gameEnter, gameLeave } from './game';
import { pauseEnter, pauseLeave } from './pause';
import { gameoverEnter, gameoverLeave } from './gameover';

const transitions = new Map();

transitions.set('loader-enter', loaderEnter);
transitions.set('loader-leave', loaderLeave);
transitions.set('intro-enter', introEnter);
transitions.set('intro-leave', introLeave);
transitions.set('tutorial-enter', tutorialEnter);
transitions.set('tutorial-leave', tutorialLeave);
transitions.set('game-enter', gameEnter);
transitions.set('game-leave', gameLeave);
transitions.set('pause-enter', pauseEnter);
transitions.set('pause-leave', pauseLeave);
transitions.set('gameover-enter', gameoverEnter);
transitions.set('gameover-leave', gameoverLeave);

export default transitions;
